<form [formGroup]="form" autocomplete="off" (ngSubmit)="save()">
    <h1 mat-dialog-title>Detalle</h1>
    <div mat-dialog-content>

        <mat-form-field class="medium-width margin-right-small">
            <mat-select formControlName="BillingConcept" placeholder="Concepto">
                <mat-option *ngFor="let billingConcept of billingConcepts" [value]="billingConcept">
                    {{ billingConcept.Name }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="f.BillingConcept.errors && f.BillingConcept.errors.required">
                Seleccione un concepto
            </mat-error>
        </mat-form-field>

        <mat-form-field class="medium-width margin-right-small">
            <mat-select formControlName="Company" placeholder="Empresa">
                <mat-option *ngFor="let company of companies" [value]="company">
                    {{ company.Name }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="f.Company.errors && f.Company.errors.required">
                Seleccione una alícuota
            </mat-error>
        </mat-form-field>

        <mat-form-field class="medium-width margin-right-small">
            <mat-select formControlName="Service" placeholder="Servicio">
                <mat-option *ngFor="let service of services" [value]="service">
                    {{ service.Name }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="f.Service.errors && f.Service.errors.required">
                Seleccione un servicio
            </mat-error>
        </mat-form-field>

        <mat-form-field class="medium-width margin-right-small">
            <mat-select formControlName="AliquotTax" placeholder="Alícuota">
                <mat-option *ngFor="let aliquotTax of aliquotTaxs" [value]="aliquotTax">
                    {{ aliquotTax.Percentage }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="f.AliquotTax.errors && f.AliquotTax.errors.required">
                Seleccione una alícuota
            </mat-error>
        </mat-form-field>

        <mat-form-field class="medium-width margin-right-small">
            <input type="number" placeholder="Importe" matInput formControlName="Amount">
            <mat-error *ngIf="f.Amount.errors && f.Amount.errors.required">
                Ingrese el importe
            </mat-error>
        </mat-form-field>

    </div>
    <div class="clearfix">
        <div class="pull-right">
            <button mat-button type="submit">Guardar</button>
            <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">Cancelar</button>
        </div>
    </div>
</form>